import {
  i
} from "./chunk.775UL347.js";

// src/components/jb-simple-page-hero/jb-simple-page-hero.css.ts
var jb_simple_page_hero_css_default = i`.sr-only{block-size:1px;border:0;clip:rect(0, 0, 0, 0);inline-size:1px;margin:-1px;overflow:hidden;padding:0;position:absolute}:host{display:block}@media(min-width: 1281px){:host{padding:40px 0 20px}}jb-heading{margin-bottom:16px;text-align:center}`;

export {
  jb_simple_page_hero_css_default
};
